import type { ChipsChangeEvent } from 'primereact/chips'
import { Chips } from 'primereact/chips'
import { useEffect, useId, useState } from 'react'
import './inputchips.scss'
import { isEqual } from 'lodash'

export interface InputChipsProps {
  label: string
  values: Array<string> | undefined
  onChange: (values: Array<string>) => void
  error?: boolean
  required?: boolean
}

function InputChips({ label, values, onChange, error, required }: InputChipsProps) {
  const id = useId()
  const [selectedValues, setSelectedValues] = useState<Array<string>>([])

  useEffect(() => {
    if (!isEqual(values, selectedValues)) {
      setSelectedValues(values ?? [])
    }
  }, [values])

  const onInputChipsValueChange = (event: ChipsChangeEvent) => {
    setSelectedValues(event.value ?? [])
    onChange(event.value ?? [])
  }

  const inputChipClass = error ? 'p-invalid' : ''

  return (
    <div className='input-chips'>
      <Chips
        id={id}
        value={selectedValues}
        onChange={onInputChipsValueChange}
        className={inputChipClass}
        separator=','
        addOnBlur
      />
      <label htmlFor={id} className='input-chips__label'>
        {label}
        {required && <span className='required'>*</span>}
      </label>
    </div>
  )
}

export default InputChips
